import { hasProtocol, isScriptProtocol, withQuery } from 'ufo';
import { useRouter } from 'vue-router';

export function defineRouteMiddleware(middleware) {
    return middleware;
}

export const navigateTo = (to, options = undefined) => {
    const toPath = typeof to === 'string' ? to : 'path' in to ? resolveRouteObject(to) : useRouter().resolve(to).href;

    const isExternalHost = hasProtocol(toPath, { acceptRelative: true });
    const isExternal = options?.external || isExternalHost;

    if (isExternal) {
        if (!options?.external) {
            throw new Error(
                'Navigating to an external URL is not allowed by default. Use `navigateTo(url, { external: true })`.'
            );
        }

        const { protocol } = new URL(toPath, typeof window !== 'undefined' ? window.location.href : 'http://localhost');

        if (protocol && isScriptProtocol(protocol)) {
            throw new Error(`Cannot navigate to a URL with '${protocol}' protocol.`);
        }
    }

    if (!isExternal) {
        return to;
    }

    const router = useRouter();

    return options?.replace ? router.replace(to) : router.push(to);
};

function resolveRouteObject(to) {
    return withQuery(to.path || '', to.query || {}) + (to.hash || '');
}
